import Queue from '@/shared/lib/queue';

type TrackPayload = {
  method: 'track' | 'trackCustom';
  event: string;
  params?: object;
  context?: {eventID: string};
};

class FacebookService {
  private readonly queue = new Queue<TrackPayload>([], 50);
  private enabled = true;

  enable() {
    this.enabled = true;
  }

  disable(clearQueue = true) {
    this.enabled = false;

    if (clearQueue) {
      this.queue.clear();
    }
  }

  track = (payload: TrackPayload) => {
    if (!this.enabled) {
      return;
    }

    this.queue.enqueue(payload);
    setTimeout(this.flushQueue);
  };

  flushQueue = () => {
    if (
      !this.enabled ||
      !this.isAvailableGlobalInstance() ||
      this.queue.isEmpty()
    ) {
      return;
    }

    const payload = this.queue.dequeue();
    if (!payload) {
      return;
    }

    try {
      window.fbq?.(
        payload.method,
        payload.event,
        {...payload.params, client_ip_address: 'AUTO'},
        payload.context
      );
    } catch (error) {
      console.error('Error logging Facebook custom event:', error);
    }

    setTimeout(this.flushQueue);
  };

  private isAvailableGlobalInstance() {
    return !(typeof window.fbq === 'undefined' || window.fbq == null);
  }
}

export const facebookService = new FacebookService();
